import { TAccountUserManagementHeaderBasicField } from '../account-user-management-header.model';

export function getUserManagementBasicFields(
  relatedPointsFlagEnabled: boolean,
): TAccountUserManagementHeaderBasicField[] {
  const basicFields: TAccountUserManagementHeaderBasicField[] = [
    {
      translationKey: 'access_level',
      class: 'accountHeader__cell--access',
    },
    {
      translationKey: 'restrict_to_only_see_certain_tags',
      class: 'accountHeader__cell--tagRestricted',
    },
    {
      translationKey: 'export',
      class: 'accountHeader__cell--export',
    },
    {
      translationKey: 'comments',
      class: 'accountHeader__cell--comments',
    },
    {
      translationKey: 'activity',
      class: 'accountHeader__cell--activity',
    },
    {
      translationKey: 'tags',
      class: 'accountHeader__cell--tags',
    },
    {
      translationKey: 'flags',
      class: 'accountHeader__cell--flags',
    },
  ];

  if (relatedPointsFlagEnabled) {
    basicFields.push({
      translationKey: 'related_point',
      class: 'accountHeader__cell--related-points',
    });
  }

  return basicFields;
}
